import React from 'react';
import { graphql } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

const Image = () => (
  <StaticImage
    src="../../images/perge_logo_fr.png"
    alt="Logo Perge"
    placeholder="blurred"
    layout="fixed"
    width={160}
    style={{ marginBottom: '5px' }}
  />
);

export default Image;
